import { useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import NavBar from "../components/navbar";
import Footer from "../components/footer";
import Contact from "../components/contact";
import Hero from "./components/hero";
import TriCards from "./components/triCards";
import BeforeAfter from "./components/beforeAfter";
import PageShell from "../components/pageShell"
import ZigZag from "./components/zigzag";
import { ButtonGroup } from "../components/basicUIComponents";
import { MetaTagHandler } from "../../../library/client/serverCallHandler";

const Dumpster = () => {

    return (
        <>
            <MetaTagHandler>
                {() => (
                    <>
                        <title>Dumpster Pad Cleaning - Flyby Shine</title>
                        <meta name="description" content="Keep Your Property Safe and Hygienic with Our Expert Dumpster Pad Cleaning Services" />
                        <meta name="keywords" content="Dumpster Pad Cleaning, Dumpster cleaning services, commercial dumpster cleaning, industrial dumpster cleaning, hygienic dumpster cleaning, expert dumpster cleaning services, safe dumpster cleaning, thorough dumpster cleaning, professional dumpster cleaning, reliable dumpster cleaning, top-quality dumpster cleaning, dumpster pad cleaning services, dumpster pad cleaning solutions, dumpster pad cleaning experts" />
                        <meta property="og:image" content="/assets/dumpster.jpg" />
                    </>
                )}
            </MetaTagHandler>
            <PageShell>
                <Hero
                    subTitle={'Commercial & Industrial'}
                    title={'Dumpster Pad Cleaning'}
                    description={`Keep Your Property Safe and Hygienic with Our Expert Dumpster Pad Cleaning Services`}
                    banner={{ image: '/assets/dumpster.jpg', alt: 'A clean dumpster' }}
                    callToAction={
                        <ButtonGroup>
                            <ButtonGroup.Button to={'https://fc.flybyshine.tech/request-work'} text={'Request an Estimate'} />
                            <ButtonGroup.Button to={'/commercial-industrial'} text={'All Services'} />
                        </ButtonGroup>
                    }

                />



                <Contact />
            </PageShell>


        </>
    )
}

export default Dumpster
